<template>
  <b-modal
      :ref="name"
      :title="title"
      cancel-title="Close"
      ok-only
      size="md"
      @close="close"
      @ok="close"
  >
    <template #modal-header>
      <div class="w-100">
        <h4 class="float-left">{{ title }}</h4>
        <div class="buttons float-right">
        </div>
      </div>
    </template>
    <b-form>

      <b-form-group id="input-group-1" :label="$t('form.label.name')" label-for="input-1">
        <b-form-input
            id="input-1"
            v-model="form.name"
            autofocus
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" :label="$t('form.label.total_price')" label-for="input-2">
        <b-form-input
            id="input-2"
            :value="form.quantity && config.quizCoinUnitPrice ? (form.quantity * config.quizCoinUnitPrice) : 0"
            readonly
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3" :label="$t('form.label.quantity')" label-for="input-3">
        <b-form-input
            id="input-3"
            type="number"
            v-model="form.quantity"
            required
        ></b-form-input>
      </b-form-group>


    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" class="mr-2" variant="secondary" @click="close">{{ $t('btn.cancel') }}</b-button>
          <b-button variant="primary"  :disabled="busy" @click="submit">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>

import axios from "axios";

export default {
  props: {},
  data() {
    return {
      name: 'default-modal',
      title: '',
      busy: false,
      config: null,
      form: {
        name: '',
        quantity: ''
      },
    }
  },

  mounted: function () {
    this.getConfig();
    this.$refs[this.name].show();
  },
  methods: {
    close() {
      this.$refs[this.name].hide();
    },
    submit() {
      const _this = this;
      this.busy = true;
      axios.post('/api/purchase/quiz-coin-package' , {...this.form, quantity: parseInt(this.form.quantity)}).then(
          () => {
            _this.busy = false;
            _this.close();
            _this.$parent.$emit('refresh-grid');
          }
      )
    },
    getConfig() {

      axios.get('/api/config/configuration/quiz_coin_purchase/default').then(
          (data) => {
            this.config = data.data.value;
          }
      )
    }
  }

}

</script>
